export const promptExamples = [
 
 {
  category: "🎵 Audio / Video Uploads",
  examples: [
    "[Upload meeting recording]",
    "[Upload Course recording]",
    "[Upload lecture video]",
    "[Upload podcast episode]",
    "[Upload interview recording]",
    "[Upload webinar]"
  ]
},
  {
    category: "🎵 Audio/Video + Instructions",
    examples: [
      "[Upload meeting recording] + 'Create 4 slides with action items and decisions made'",
      "[Upload Course recording] +'Create 6 slides 4 bullet points in each slide'",
      "[Upload lecture video] + 'Make 5 Slides for this tutorial 3 bullet points in each slide'",
      "[Upload podcast episode] + 'Give me 5 slides highlighting main talking points and quotes'",
      "[Upload interview recording] + 'Summarize candidate responses and create 5 evaluation slides'",
      "[Upload webinar] + 'Extract key takeaways and create a summary 7 slides presentation'"
    ]
  },
  
  {
    category: "📝 Text-Based Presentations",
    examples: [
      "Give me 10 slides about the history of the internet, from ARPANET to modern web3",
      "Make 8 slides explaining how photosynthesis works for middle school students with diagrams",
      "Business pitch deck for a sustainable fashion startup seeking $2M seed funding",
      "Give me 12 slides with a step-by-step tutorial on building a React app from scratch for beginners",
      "Create 6 slides for quarterly financial review: revenue trends, expenses, and profit margins for Q1 2024"
    ]
  },
  
  {
    category: "📄 Long Content Examples",
    examples: [
      `Give me 6 slides about this:

The Industrial Revolution transformed society in three major phases:

First Phase (1760-1840): Steam power revolutionized manufacturing. James Watt's steam engine enabled factories to operate independently of water sources. Textile production increased 500% with mechanized looms.

Second Phase (1870-1914): Electricity and steel production dominated. Thomas Edison's light bulb extended working hours. Assembly lines increased productivity by 300%.

Third Phase (1969-Present): Digital revolution with computers and automation. Internet connectivity transformed global commerce. AI and robotics continue reshaping industries.

Key impacts: Urbanization grew from 10% to 80%, life expectancy doubled, and GDP per capita increased 15x.`,

      `Create 8 slides with 3 bullet points each:

Climate Change Solutions - A Comprehensive Overview:

Problem Statement: Global temperatures have risen 1.1°C since pre-industrial times. We need to limit warming to 1.5°C to avoid catastrophic effects.

Renewable Energy Transition:
- Solar: Cost dropped 90% in 10 years, now cheapest energy source
- Wind: Offshore wind capacity doubled since 2015
- Hydro: 16% of global electricity generation

Carbon Capture Technologies:
- Direct air capture removes CO2 from atmosphere
- Enhanced weathering accelerates natural processes
- Ocean alkalinity enhancement stores carbon in seawater

Policy Solutions:
- Carbon pricing incentivizes emissions reduction
- Green subsidies support clean technology adoption
- International agreements like Paris Accord set targets

Individual Actions:
- Reduce meat consumption (18% of emissions from livestock)
- Use public transit and EVs
- Energy-efficient homes save 30% on utilities

Timeline: We have until 2030 to cut emissions 45% to stay on track.`
    ]
  },
  {
    category: "🎯 Specific Slide-by-Slide Requests",
    examples: [
      "Create 5 slides: Slide 1 - Title with company logo, Slide 2 - Problem statement, Slide 3 - Our solution, Slide 4 - Market size, Slide 5 - Team bios",
      "Make 8 slides about coffee brewing methods. Each slide covers one method: espresso, pour-over, French press, cold brew, AeroPress, Moka pot, drip, and Turkish coffee",
      "Generate a 12-month project timeline presentation. One slide per month showing milestones, deliverables, and team responsibilities",
      "Give me 6 slides with 4 bullet points each comparing iPhone vs Samsung Galaxy across price, camera, battery, display, ecosystem, and performance",
      "Make a training deck: Slide 1 - Welcome, Slides 2-5 - Core concepts, Slides 6-8 - Hands-on exercises, Slide 9 - Resources, Slide 10 - Quiz"
    ]
  },
  {
    category: "🚀 Creative & Unique",
    examples: [
      "Design a choose-your-own-adventure presentation about starting a business with branching decision points",
      "Give me 7 slides for an interactive product demo walkthrough with before/after comparisons and feature highlights",
      "Make a visual storytelling presentation about my journey learning to code with challenges and breakthroughs",
      "Create 5 slides with a recipe presentation for homemade pizza including ingredient lists, step-by-step photos, and tips",
      "Build a travel itinerary presentation for 2 weeks in Japan with daily schedules, must-see spots, and budget breakdown"
    ]
  },
  {
    category: "💼 Business & Professional",
    examples: [
      "Give me 4 slides with 5 bullet points each for SWOT analysis presentation for entering the electric vehicle market: strengths, weaknesses, opportunities, threats",
      "Create 10 slides for employee onboarding deck covering company culture, benefits, tools setup, team introductions, and first 90 days roadmap",
      "Marketing campaign results: audience demographics, engagement metrics, ROI analysis, and recommendations for Q2",
      "Give me 8 slides showing product roadmap presentation with Q1-Q4 features, development phases, beta testing schedule, and launch dates",
      "Investor update: user growth charts, revenue streams, burn rate, competitive landscape, and funding ask"
    ]
  },
  {
    category: "🎓 Education & Learning",
    examples: [
      "Give me 5 slides explaining the water cycle for 5th graders with illustrations: evaporation, condensation, precipitation, collection",
      "Create 12 slides covering Greek mythology: the 12 Olympian gods, their powers, symbols, and famous myths",
      "Introduction to cryptocurrency: blockchain basics, Bitcoin vs Ethereum, wallets, mining, and investment risks",
      "Give me 9 slides with 3 bullet points each for World War 2 timeline with major battles, turning points, key leaders, and impact on modern geopolitics",
      "Human body systems overview: circulatory, respiratory, digestive, nervous, and skeletal systems with diagrams"
    ]
  }
];